function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 3H4V5H20V3Z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 8H9V10H20V8Z",
  fill: "#C4C4C4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 13H9V15H20V13Z",
  fill: "#C4C4C4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20 18H4V20H20V18Z",
  fill: "#C4C4C4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.5L4.25 14.5311L4.25 8.46891L8 11.5Z",
  fill: "#C4C4C4"
});

var SvgIndent = function SvgIndent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIndent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indent.4ab566a9.svg";
export { ForwardRef as ReactComponent };